<template>
  <div>
    <BasicNavigation></BasicNavigation>
  </div>
  <div>
  <div class="flex flex-col items-center min-h-screen bg-white py-10">
   
    <div class="w-full max-w-2xl">
      <div class="text-2xl font-semibold leading-6 flex-1 mx-2 pb-4">Registreren</div>
      <card>
        <template v-slot>
          <div class="mt-4 flex items-center">
            <ListBulletIcon class="h-6 w-6 text-gray-700" />
            <div class="text-lg font-bold text-gray-700 ml-2">Voorbereiding</div>
          </div>
          <div class="mt-4">
            <p class="text-l font-semibold text-gray-700 mt-2">
              Houd de volgende gegevens, indien beschikbaar, bij de hand:
            </p>
            <ul class="list-disc list-inside mt-2 text-gray-600 text-sm">
              <li v-for="(item, index) in registerRequirements" :key="index" class="text-sm">{{ item }}</li>
            </ul>
          </div>
          <div class="mt-4 flex gap-4 text-pdsPrimaryColor text-sm font-bold">
            <a href="https://www.vektis.nl/agb-register/zoeken" target="_blank">AGB-code opzoeken →</a>
            <a href="https://zoeken.bigregister.nl/zoeken/kenmerken" target="_blank">BIG-code opzoeken →</a>
          </div>
          <p class="mt-4 text-sm text-gray-700 font-semibold mb-4">
            Wij verwachten uw registratie binnen 2 dagen te hebben verwerkt.
          </p>
          <Alert
            :html="true"
            :htmlMessage="alertMessage"
            @customLinkClick="redirectToLogin"
            type="info"
          ></Alert>
          <div class="pt-6">
            <button
              type="button"
              @click="redirectToRegistration()"
              class="text-center text-white bg-pdsPrimaryColor rounded-full border border-pdsPrimaryColor cursor-pointer w-40 h-10"
            >
              Start registratie
            </button>
          </div>
        </template>
      </card>
    </div>
  </div>
  </div>
</template>

<script>
import router from '@/router';
import { ref } from 'vue';
import { ListBulletIcon } from '@heroicons/vue/20/solid';
import BasicNavigation from '@/components/webcomponents/BasicNavigation';


export default {
  name: 'AccountRegistration',
  components: {
    ListBulletIcon,
    BasicNavigation
  },

  setup() {
    const alertMessage = ref(
      '<span class="text-[#143344]""> Wilt u een collega toevoegen aan een instelling of afdeling? <br>  <a class="font-bold block mt-2 underline underline-offset-8 cursor-pointer">Ga naar collega toevoegen →</a><span>'
    );
    const registerRequirements = [
      'Uw persoonlijke AGB-code, indien niet beschikbaar een BIG-nummer',
      'De AGB-code van uw praktijk of werkgever',
      'Uw zakelijke gegevens',
      'De gegevens van uw praktijk of werkgever'
    ];
    return {
      alertMessage,
      registerRequirements
    };
  },
  created() {},
  methods: {
    redirectToLogin() {
      router.push('/inloggen');
    },
    redirectToRegistration() {
      router.push('/accountregistration');
    }
  }
};
</script>
